/**
 * { loaded: bool, data: as_link | null }
 * `loaded` evita pedir /me en cada navegación: el gate consulta una vez por sesión y HomePage
 * refresca al cargar el perfil.
 */
const initial = { loaded: false, data: null };

export default (state = initial, action) => {
    switch (action.type) {
        case 'AS_LINK_LOADED':
            return { loaded: true, data: action.asLink };
        case 'AS_LINK_UNAVAILABLE':
            return { loaded: true, data: null };
        case 'AS_LINK_RESET':
            return initial;
        default:
            return state;
    }
};
